import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../providers/AuthProvider';

export default function Protected({
  children,
  requireAdmin = false
}: {
  children: React.ReactNode;
  requireAdmin?: boolean;
}) {
  const navigate = useNavigate();
  const { user, loaded, groups, isTrialExpired } = useAuth();

  useEffect(() => {
    if (!loaded) {
      return;
    }

    // If trial is expired, redirect to sign-in (modal will show there)
    if (isTrialExpired) {
      navigate('/auth/sign-in');
      return;
    }

    // If no user, redirect to sign-in
    if (!user) {
      navigate('/auth/sign-in');
      return;
    }

    // Check admin requirement
    if (requireAdmin && groups.indexOf('admin') === -1) {
      navigate('/unauthorized');
    }
  }, [loaded, user, groups, requireAdmin, isTrialExpired, navigate]);

  // Show loading state
  if (!loaded) {
    return null;
  }

  // Don't render if trial expired or no user (will redirect via useEffect)
  if (isTrialExpired || !user || (requireAdmin && groups.indexOf('admin') === -1)) {
    return null;
  }

  return <>{children}</>;
}
